import { getCookie, setCookie } from "@/utils/cookies";
import { createClientOnlyFn } from "@tanstack/react-start";
import ms from "ms";

const cookieName = "app-menu-sect";
const ttl = ms("1y");
export const getAppMenuSect = async () => {
  const sect = await getCookie(cookieName);
  return sect || null;
};

export const setAppMenuSect = createClientOnlyFn((sect: string) => {
  setCookie(cookieName, sect, { expires: ttl });
});
